import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import React from 'react';

interface Props {
  readonly label: string;
  readonly value?: boolean;

  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
}

export const FormCheckbox = (props: Props): React.ReactElement => {
  const { label, value, onChange } = props;

  return (
    <FormControlLabel
      sx={styles.control}
      control={<Checkbox size="small" checked={value} onChange={onChange} />}
      label={
        <Typography fontSize={16} whiteSpace="nowrap" color="text.primary">
          {label}
        </Typography>
      }
    />
  );
};

const styles: Record<string, SystemStyleObject> = {
  control: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
  },
};
